import React from 'react'

const Skeleton = () => {
  return (
    <div className="flex flex-col items-start gap-1 mt-3">
        <div className="w-full h-7 bg-gray-300 rounded-lg animate-pulse mb-2"></div>
        <div className="w-full h-7 bg-gray-300 rounded animate-pulse mb-2"></div>
        <div className="w-full h-7 bg-gray-300 rounded animate-pulse mb-2"></div>
        <div className="w-full h-7 bg-gray-300 rounded animate-pulse mb-2"></div>
        <div className="w-full h-7 bg-gray-300 rounded animate-pulse"></div>
    </div>
  )
}

export default Skeleton